import { useRef } from 'react';
import { useScaleCanvas } from '../../use-scale-canvas';
import arrowYellow from '../OrgImages/arrowyellow.svg';
import logos from '../OrgImages/Logos.svg';

const CANVAS_W = 640;
const CANVAS_H = 780;

export const OrgLogoShowcase = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const { wrapperStyle, canvasStyle } = useScaleCanvas(sectionRef, CANVAS_W, CANVAS_H, 'width');

  return (
    <section
      ref={sectionRef}
      className='relative h-full w-full overflow-hidden bg-secondary-brand-25'
    >
      <div className='flex h-full w-full justify-center'>
        <div style={wrapperStyle}>
          <div style={canvasStyle}>
            <h1 className='absolute top-10 px-8 m-0 text-display-xl font-bold text-gray-700 tracking-[-1.2px]'>
              Join hundreds of <br />
              social enterprises <br />
              turning purpose <br />
              into progress
            </h1>
            <img
              src={arrowYellow}
              alt=''
              className='absolute'
              style={{ top: 310, left: 405, width: 42, height: 105 }}
            />
            <img
              src={logos}
              alt=''
              className='absolute'
              style={{ top: 420, left: 0, width: 640, height: 139 }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
